/* Edge — scroll: prints develop as they arrive, a live counter on the frame edge */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var ease = 'cubic-bezier(.22,.61,.36,1)';

  var css =
    /* 1. develop */
    '.sx .grid > a img{opacity:.28;filter:grayscale(1) contrast(.55) brightness(1.45) blur(3px);transform:translateY(14px);' +
      'transition:opacity 1100ms ' + ease + ',filter 1400ms ' + ease + ',transform 900ms ' + ease + ';transition-delay:var(--d,0ms)}' +
    '.sx .grid > a > span{opacity:0;transition:opacity 700ms ease;transition-delay:calc(var(--d,0ms) + 350ms)}' +
    '.sx .grid > a.is-dev img{opacity:1;filter:none;transform:none}' +
    '.sx .grid > a.is-dev > span{opacity:1}' +
    /* 2. counter */
    '.ctr{position:fixed;right:22px;top:50%;transform:translateY(-50%);writing-mode:vertical-rl;z-index:18;pointer-events:none;opacity:0;transition:opacity 400ms ease;white-space:nowrap;max-height:70vh;overflow:hidden;text-overflow:ellipsis}' +
    '.ctr.is-on{opacity:1}' +
    '.ctr b{font-weight:500;color:var(--ink)}' +
    '@media (max-width:749px){.ctr{display:none}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  /* 1. Prints develop like paper in a tray, a beat after their neighbour */
  var cards = Array.prototype.slice.call(document.querySelectorAll('.grid > a'));
  if (cards.length && !reduce && hasIO) {
    root.classList.add('sx');
    var io = new IntersectionObserver(function (es) {
      var k = 0;
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.style.setProperty('--d', Math.min(k, 5) * 90 + 'ms');
        e.target.classList.add('is-dev');
        io.unobserve(e.target);
        k++;
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    cards.forEach(function (c) { io.observe(c); });
    // never leave a print undeveloped (e.g. print preview, odd browsers)
    setTimeout(function () { cards.forEach(function (c) { if (c.getBoundingClientRect().top < innerHeight) c.classList.add('is-dev'); }); }, 2500);
  }

  /* 2. Contact-sheet counter on the right edge while the index is on screen */
  var grid = document.querySelector('.index .grid') || document.querySelector('.wrap .grid');
  if (grid && cards.length > 1) {
    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > a'));
    var total = items.length, pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var ctr = document.createElement('div');
    ctr.className = 'ctr mute';
    ctr.setAttribute('aria-hidden', 'true');
    document.body.appendChild(ctr);
    var last = -1, ticking = false, gridOn = false;
    var titleOf = function (a) {
      var s = a.querySelector('span');
      return s ? s.textContent.replace(/^\(\d+\)\s*/, '') : '';
    };
    var update = function () {
      ticking = false;
      var r = grid.getBoundingClientRect();
      gridOn = r.top < innerHeight * 0.6 && r.bottom > innerHeight * 0.4;
      ctr.classList.toggle('is-on', gridOn);
      if (!gridOn) return;
      var mid = innerHeight / 2, best = 0, bd = 1e9;
      for (var i = 0; i < total; i++) {
        var b = items[i].getBoundingClientRect();
        var d = Math.abs((b.top + b.bottom) / 2 - mid) + Math.abs((b.left + b.right) / 2 - innerWidth / 2) * 0.15;
        if (d < bd) { bd = d; best = i; }
      }
      if (best !== last) {
        last = best;
        ctr.innerHTML = '<b>(' + pad(best + 1) + ' / ' + pad(total) + ')</b> ' + titleOf(items[best]);
      }
    };
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll);
    update();
  }

})();
